import { render } from "./userTelaEventos.vue?vue&type=template&id=8789f51e&scoped=true"
import script from "./userTelaEventos.vue?vue&type=script&lang=js"
export * from "./userTelaEventos.vue?vue&type=script&lang=js"

import "./userTelaEventos.vue?vue&type=style&index=0&id=8789f51e&scoped=true&lang=css"

import exportComponent from "F:\\Projetos VueJs\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8789f51e"]])

export default __exports__